import { render, staticRenderFns } from "./Datos_est.vue?vue&type=template&id=b3049440"
import script from "./Datos_est.vue?vue&type=script&lang=js"
export * from "./Datos_est.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports